import React, { useCallback } from 'react'
import { Paragraph, Radio } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { useDarkMode } from '../../../DarkModeProvider'
import SettingsSection from './SettingsSection'

const captionOverrideCss = css`
  & p {
    position: relative;
    inset-inline-start: 28px;
  }
`

export default function DarkMode(): JSX.Element {
  const [t] = useTranslation()
  const [isDarkMode, isAutomaticMode, updateDarkMode] = useDarkMode()

  const onChange = useCallback(
    (event): void => {
      const value = event.target.value
      if (value === 'off') updateDarkMode(false)
      else if (value === 'on') updateDarkMode(true)
      else updateDarkMode(undefined)
    },
    [updateDarkMode]
  )

  return (
    <SettingsSection heading={t('tree-person.appearance.label')}>
      <Radio
        name="dark-mode"
        value="off"
        data-testid="dark-mode:off"
        label={t('tree-person.appearance.light.label')}
        checked={!isAutomaticMode && !isDarkMode}
        onChange={onChange}
      />
      <Radio
        name="dark-mode"
        value="on"
        data-testid="dark-mode:on"
        label={t('tree-person.appearance.dark.label')}
        checked={!isAutomaticMode && isDarkMode}
        onChange={onChange}
      />
      <Radio
        name="dark-mode"
        value="automatic"
        data-testid="dark-mode:automatic"
        label={t('tree-person.appearance.automatic.label')}
        checked={isAutomaticMode}
        onChange={onChange}
      />
      <div css={captionOverrideCss}>
        <Paragraph size="xs">{t('tree-person.appearance.automatic-description.label')}</Paragraph>
      </div>
    </SettingsSection>
  )
}
